import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
const buyers = [{
  name: 'Alejandro R.',
  city: 'Miami, FL'
}, {
  name: 'Gabriela M.',
  city: 'Houston, TX'
}, {
  name: 'José Luis P.',
  city: 'Los Angeles, CA'
}, {
  name: 'María Fernanda S.',
  city: 'Chicago, IL'
}, {
  name: 'Carlos E.',
  city: 'Dallas, TX'
}, {
  name: 'Ana Patricia V.',
  city: 'New York, NY'
}, {
  name: 'Diego H.',
  city: 'Phoenix, AZ'
}, {
  name: 'Valentina C.',
  city: 'San Antonio, TX'
}, {
  name: 'Fernando G.',
  city: 'Orlando, FL'
}, {
  name: 'Lucía T.',
  city: 'Atlanta, GA'
}, {
  name: 'Ricardo N.',
  city: 'Denver, CO'
}, {
  name: 'Camila D.',
  city: 'Las Vegas, NV'
}, {
  name: 'Andrés F.',
  city: 'Charlotte, NC'
}, {
  name: 'Sofía B.',
  city: 'Tampa, FL'
}, {
  name: 'Miguel Á.',
  city: 'San Diego, CA'
}, {
  name: 'Daniela L.',
  city: 'Austin, TX'
}, {
  name: 'Javier M.',
  city: 'Nashville, TN'
}, {
  name: 'Isabella R.',
  city: 'Portland, OR'
}];
function getRandomBuyer() {
  return buyers[Math.floor(Math.random() * buyers.length)];
}
function getTimeAgo(): string {
  const minutes = Math.floor(Math.random() * 12) + 1;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer);
  const [timeAgo, setTimeAgo] = useState(getTimeAgo);
  useEffect(() => {
    // Show first popup after 8 seconds, then every 15 seconds
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 8000);
    const interval = setInterval(() => {
      showPopup();
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  function showPopup() {
    setBuyer(getRandomBuyer());
    setTimeAgo(getTimeAgo());
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  }
  return <AnimatePresence data-id="element-135">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 left-4 z-50 max-w-xs" data-id="element-136">
          <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-4 flex items-center gap-3" data-id="element-137">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 flex items-center justify-center flex-shrink-0" data-id="element-138">
              <ShieldCheck className="w-5 h-5 text-white" data-id="element-139" />
            </div>
            <div className="min-w-0" data-id="element-140">
              <p className="font-heading font-bold text-navy text-sm leading-tight truncate" data-id="element-141">
                {buyer.name}
              </p>
              <p className="text-gray-500 text-xs font-body" data-id="element-142">
                Compró Imperio Americano
              </p>
              <p className="text-gray-400 text-[11px] font-heading mt-0.5" data-id="element-143">
                📍 {buyer.city} · {timeAgo}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}